/* eslint-disable */
import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConfigD from './util/ConfigD';
import Helpers from './util/Helpers'
import SelectMeioComunicacaoDenuncia from './common/SelectMeioComunicacaoDenuncia'

//import * as mensagemActions from './actions/mensagemActions'
import './css/denunciaForm.css'
import './css/loginForm.css'
import './css/sliderDiv.css'
import './css/imgSelected.css'
import $ from 'jquery';
import Alert from 'react-s-alert';


class DenunciaForm extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            showError:'',
            meiosConhecimento: Helpers.DominioMeioConhecimentoDenuncia()
        };
        this.getMeiosConhecimentoDenunciaSelecionada = this.getMeiosConhecimentoDenunciaSelecionada.bind(this);
       }

    getMeiosConhecimentoDenunciaSelecionada(val){
        this.props.getMeiosConhecimentoDenunciaSelecionada(val)
    }
    render() {
        // if ($.isEmptyObject(this.props.historico) ||
        //     $.isEmptyObject(this.props.historico.mClassificacaoOperador) ||
        //     this.props.historico.mClassificacaoOperador.mIdClassificacao!==1){
        //    return <div/>
        // }

    return (

        <div>
            
            <div className="clearfix"></div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="contact-box-Blue widget">
                    <h3 className='titulo-Contact-box-Blue'>Dados da denúncia</h3>
                    <i className="fa fa-bullhorn"></i>
                    <p>Nem todos os campos abaixo são obrigatórios, mas todos servem para complementar o seu relato com mais informações que serão de extrema importância para nos ajudar a analisar sua denúncia.</p>
                    <p> Por favor, preencha com atenção:</p>
                </div>
            </div>            
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Quando e onde o fato ocorreu? Você consegue dizer com precisão dia, horário e local? Informe também se continua ocorrendo:</b></label>
                        <input type="text" className="form-control" placeholder="" ref='txtDenunciaQuandoOnde' name="txtDenunciaQuandoOnde" id='txtDenunciaQuandoOnde' onChange={() => this.props.onChangetxtDenunciaQuandoOnde(this.refs.txtDenunciaQuandoOnde.value, this.refs.errQuandoOnde )} />                        
                        <span ref='errQuandoOnde' style={{ display: '' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Indique como você tomou conhecimento do ocorrido:</b></label>
                        <div className="clearfix"></div>
                        <SelectMeioComunicacaoDenuncia meiosConhecimento={this.state.meiosConhecimento} multi={false} getMeiosConhecimentoDenunciaSelecionada={this.getMeiosConhecimentoDenunciaSelecionada}/>
                        <span ref='errMeioConhecimento' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>            
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Existem testemunhas que possam auxiliar na comprovação do fato? Se sim, cite até 3 (três) testemunhas.</b></label>
                        <input type="text" className="form-control" placeholder="" ref='txtDenunciaTestemunha' name="txtDenunciaTestemunha" id='txtDenunciaTestemunha' onChange={() => this.props.onChangetxtDenunciaTestemunha(this.refs.txtDenunciaTestemunha.value, this.refs.errTestemunha)} />                        
                        <span ref='errTestemunha' style={{ display: '' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Se for o caso, indique o valor financeiro envolvido no fato relatado:</b></label>
                        <input type="text" className="form-control" placeholder="" ref='txtDenunciaValor' name="txtDenunciaValor" id='txtDenunciaValor' onChange={() => this.props.onChangetxtDenunciaValor(this.refs.txtDenunciaValor.value)} />                        
                        <span ref='errValor' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Há quanto tempo você tem conhecimento sobre o fato?</b></label>
                        <input type="text" className="form-control" placeholder="" ref='txtDenunciaTempo' name="txtDenunciaTempo" id='txtDenunciaTempo' onChange={() => this.props.onChangetxtDenunciaTempo(this.refs.txtDenunciaTempo.value, this.refs.errTempo)}  />                        
                        <span ref='errTempo' style={{ display: '' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Descreva evidências ou informações que você julgue relevantes para orientar / subsidiar a apuração dos fatos relatados. Como exemplo podem ser usadas fotos, gravações de reuniões, contratos, e-mail, mensagens de celular, gravações de câmeras de segurança. Especifique da forma mais detalhada possível:</b></label>
                        <textarea rows="4" cols="50" className="form-control" name="txtDenunciaDocumento" id='txtDenunciaDocumento' placeholder="" ref='txtDenunciaDocumento' onChange={() => this.props.onChangetxtDenunciaDocumento(this.refs.txtDenunciaDocumento.value, this.refs.errDocumento)} />
                        <span ref='errDocumento' style={{ display: '' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Alguma liderança do SEBRAE tem ciência do ocorrido?</b></label>
                        <input type="text" className="form-control" placeholder="" ref='txtDenunciaLideranca' name="txtDenunciaLideranca" id='txtDenunciaLideranca' onChange={() => this.props.onChangetxtDenunciaLideranca(this.refs.txtDenunciaLideranca.value, this.refs.errLideranca)}  />                        
                        <span ref='errLideranca' style={{ display: '' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Você sofreu ou presenciou alguma ameaça direta ou indireta para evitar a denúncia desse fato?</b></label>
                        <input type="text" className="form-control" placeholder="" ref='txtDenunciaAmeaca' name="txtDenunciaAmeaca" id='txtDenunciaAmeaca' onChange={() => this.props.onChangetxtDenunciaAmeaca(this.refs.txtDenunciaAmeaca.value, this.refs.errAmeaca)} />
                        <span ref='errAmeaca' style={{ display: '' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div>

            {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="form-group">
                    <div className="input-icon">
                        <label><b>Descreva outras evidências ou informações que você julgue relevantes para orientar / subsidiar a apuração dos fatos relatados:</b></label>
                        <textarea rows="4" cols="50" className="form-control" name="txtDenunciaEvidencia" id='txtDenunciaEvidencia' placeholder="" ref='txtDenunciaEvidencia' onChange={() => this.props.onChangetxtDenunciaEvidencia(this.refs.txtDenunciaEvidencia.value, this.refs.errEvidencia)} />
                        <span ref='errEvidencia' style={{ display: 'none' }} className="has-error">*Campo obrigatório</span>
                    </div>
                </div>
            </div> */}

        </div>
    );
  }
}

DenunciaForm.protoType = {

}
DenunciaForm.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps) {
    
    return {
        //conhecimentosDenuncia: state.conhecimentosDenuncia
    };
}

function mapDispatchToProps(dispatch) {
    return {

        //actions: bindActionCreators(mensagemActions, dispatch)

    };

}

export default connect(mapStateToProps, mapDispatchToProps)(DenunciaForm);



/** WEBPACK FOOTER **
 ** ./src/components/DenunciaForm.js
 **/